import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService, HttpService, IdDescription } from '../../../../tms-shared';

@Injectable({
  providedIn: 'root',
})
export class BaseReferenceService extends BaseService {
  constructor(protected baseRoute: string, protected httpService: HttpService) {
    super(baseRoute, httpService);
  }

  get(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(this.apiUrl);
  }
}
